/**
 * Backend base URL used by frontend API calls.
 * Reads from the environment variable `REACT_APP_BACKEND_URL` and trims whitespace.
 * Falls back to an empty string when the env var is not set.
 */
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').trim();

/**
 * Generate a short random alphanumeric seed string.
 * The seed is 10 characters long and is suitable for use as a game seed
 * or other non-cryptographic identifiers.
 * @returns {string} Random 10-character alphanumeric string
 */
export const generateSeed = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Format a Date object as a local YYYY-MM-DD string.
 * Defaults to the current date when no argument is provided.
 * @param {Date} [date=new Date()] - Date to format
 * @returns {string} Date string in YYYY-MM-DD format
 */
export const formatLocalDate = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
